import React, { SVGProps } from "react";
export default function SupUserAnon007(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 5.3837L10 0.767395L8.43167 1.67238M18 5.3837V14.6163L16.3705 15.5566M18 5.3837L16.3705 6.32396M10 19.2326L2 14.6163V5.3837M10 19.2326V10M10 19.2326L11.4822 18.3774V16.4968M2 5.3837L10 10M2 5.3837L3.56996 4.47778L5.13991 5.40381M10 10L11.4822 9.14475M11.4822 9.14475V16.4968M11.4822 9.14475L5.13991 5.40381M14.7411 7.26422L13.1116 8.20449M14.7411 7.26422C14.7411 9.25999 14.7411 12.55 14.7411 14.6163M14.7411 7.26422L8.43167 3.51044M16.3705 6.32396V15.5566M16.3705 6.32396L8.43167 1.67238M16.3705 15.5566L14.7411 14.6163M13.1116 8.20449V17.4371M13.1116 8.20449L5.13991 3.57185M13.1116 17.4371L14.7411 16.4968C14.7411 16.4968 14.7411 15.7363 14.7411 14.6163M13.1116 17.4371L11.4822 16.4968M5.13991 3.57185L6.86335 2.57736L8.43167 3.51044M5.13991 3.57185V5.40381M8.43167 1.67238V3.51044"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
